/**
 * miniChip — the tiny pill shape for the DEV chip clusters docked on the
 * minimap (layout-switch toggles + layout debug controls). Deliberately
 * distinct from the full-size `HudChip` pill used for PROPER board controls:
 * these read as debug, not primary. Both minimap dev groups derive their pill
 * from here so they stay visually identical.
 */
export type MiniChipAccent = "sky" | "emerald" | "amber";

const ON: Record<MiniChipAccent, string> = {
  sky: "bg-sky-500/25 text-sky-300 border-sky-400/40",
  emerald: "bg-emerald-500/25 text-emerald-300 border-emerald-400/40",
  amber: "bg-amber-500/25 text-amber-300 border-amber-400/40",
};

const OFF = "bg-slate-800/(--tint-strong) text-slate-500 border-slate-600/(--tint-muted)";

/** The shared tiny-pill class. `active` fills it with its accent colour. */
export function miniChipClass(active: boolean, accent: MiniChipAccent = "sky"): string {
  return (
    "pointer-events-auto select-none rounded border px-1.5 py-0.5 text-[9px] font-mono leading-none " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 " +
    "disabled:cursor-not-allowed disabled:opacity-50 " +
    (active ? ON[accent] : OFF)
  );
}
